/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'
export class AuthService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Used to login using phone number verified using Firebase.
   *
   * @param requestBody Request payload needs to have an `idToken` required to
   * identify user to check that user has verified his phone number
   * using Firebase Phone Auth.
   *
   * Check https://firebase.google.com/docs/auth/web/phone-auth for more
   * details.
   *
   * @returns any Phone number verification has been successfully completed.
   * @throws ApiError
   */
  public postAuthLoginPhone(requestBody: {
    idToken: string
    phoneNumber: string
  }): CancelablePromise<{
    /**
     * MobileAuth JWT access token.
     */
    accessToken: string
    /**
     * MobileAuth JWT refresh token.
     */
    refreshToken: string
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/auth/login/phone',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Used to login using phone number & password.
   *
   * @param requestBody
   * @returns any
   * @throws ApiError
   */
  public postAuthLoginPhonePassword(requestBody: {
    phoneNumber: string
    password: string
  }): CancelablePromise<{
    /**
     * MobileAuth JWT access token.
     */
    accessToken: string
    /**
     * MobileAuth JWT refresh token.
     */
    refreshToken: string
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/auth/login/phone-password',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Used to exchange code obtained using OAuth2 login into
   * access / refresh tokens.
   * Creates a new user when oauth user id is not connected to
   * any existing one.
   *
   * @param requestBody
   * @returns any Login / signup succeeded.
   * @throws ApiError
   */
  public postAuthLoginOAuth2(requestBody: {
    code: string
    projectId: string
    providerId: string
    /**
     * A random string generated for OAuth2 flow that was later hashed and send in the request as `code_challenge`.
     */
    codeVerifier: string
  }): CancelablePromise<{
    /**
     * MobileAuth JWT access token.
     */
    accessToken: string
    /**
     * MobileAuth JWT refresh token.
     */
    refreshToken: string
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/auth/login/oauth2',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Used to login using credential obtained from Google Sign-In.
   * Creates a new user when Google user is not connected to
   * any existing one.
   *
   * @param requestBody
   * @returns any Login / signup succeeded.
   * @throws ApiError
   */
  public postAuthLoginGoogleSignIn(requestBody: {
    /**
     * Credential obtained by client using Sign-in with Google. https://developers.google.com/identity/gsi/web/guides/overview
     */
    credential: string
    projectId: string
  }): CancelablePromise<{
    /**
     * MobileAuth JWT access token.
     */
    accessToken: string
    /**
     * MobileAuth JWT refresh token.
     */
    refreshToken: string
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/auth/login/google-signin',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Sends the verification message containing an OTP token used to register a
   * new or login an existing user using email address and OTP.
   *
   * @param requestBody
   * @returns any Success
   * @throws ApiError
   */
  public postAuthLoginEmailOtpRequest(requestBody: {
    email: string
    /**
     * Project for which user requested email OTP login. Used to customize email template.
     */
    projectId: string
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/auth/login/email-otp/request',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Used to finalize user registration/login with OTP.
   * Requires the token generated by an email login request.
   *
   * @param requestBody
   * @returns any User authenticated and can change their password.
   * @throws ApiError
   */
  public postAuthLoginEmailOtp(requestBody: { token: string; email: string }): CancelablePromise<{
    /**
     * MobileAuth JWT access token.
     */
    accessToken: string
    /**
     * MobileAuth JWT refresh token.
     */
    refreshToken: string
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/auth/login/email-otp',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Endpoint to refresh user access token.
   * @param requestBody
   * @returns any Tokens refreshed.
   * @throws ApiError
   */
  public postAuthRefresh(requestBody: { refreshToken: string }): CancelablePromise<{
    /**
     * MobileAuth JWT access token.
     */
    accessToken: string
    /**
     * MobileAuth JWT refresh token.
     */
    refreshToken: string
  }> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/v2/auth/refresh',
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Body is invalid (invalid structure or requirements). Details are included in the response.`
      }
    })
  }
  /**
   * Returns public key for JWT token verification in the ASN.1 encoded SubjectPublicKeyInfo format.
   * @returns any The key.
   * @throws ApiError
   */
  public getAuthKey(): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/v2/auth/key'
    })
  }
}
